export default __webpack_public_path__ + "41353f52271f468350c95d221628ac8c.svg";